import React from "react";
import Scrollable from "../../../Shared/Edit/Scrollable";
import Sections from "../Sections/Sections";

const Layout = ({ draggedAttributeId, onDropAttribute }) => {
    return (
        <Scrollable noPadding={true} >
            <Sections draggedAttributeId={draggedAttributeId} onDropAttribute={onDropAttribute} />
        </Scrollable>
    );
}

export default Layout;